<template>
  <b-row>
    <b-col cols="12" class="mt-3">
      <b-card header-class="custom-header-bg">
        <template v-slot:header>
          <div class="border-left custom-header-border float-left">
            <span class="mb-0 h3 ml-2">編輯個人資料</span>
          </div>
        </template>
        <b-row>
          <b-col md="4" offset-md="4" cols="10" offset="1" v-if="showDataForm">
            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <b-form-group id="username-field" label="管理者帳號" label-for="username" description="不可更改">
                <b-form-input id="username" v-model="username" disabled></b-form-input>
              </b-form-group>
              <b-form-group id="name-field" label="管理者名稱" label-for="name" :state="isNameValid" :invalid-feedback="invalidNameFeedback">
                <b-form-input id="name" v-model="name" :disabled="busy" :state="isNameValid"></b-form-input>
              </b-form-group>
              <b-form-group id="email-field" label="電子信箱" label-for="email" :state="isEmailValid" :invalid-feedback="invalidEmailFeedback">
                <b-form-input id="email" v-model="email" :disabled="busy" :state="isEmailValid"></b-form-input>
              </b-form-group>
              <label>密碼：</label>
              <b-link @click="currShow='reset-form'">設定新密碼</b-link>
              <hr>
              <b-button type="submit" variant="primary" class="float-right" :disabled="busy" >
                <b-spinner v-if="busy" small label="Spinning"></b-spinner>
                <span v-else>送出</span>
              </b-button>
            </b-form>
          </b-col>
          <b-col md="4" offset-md="4" cols="10" offset="1" v-if="showResetPwdForm">
            <b-form @submit.prevent="onSubmitReset">
              <!--b-form-group
                id="old_pwd-field"
                label="舊密碼"
                label-for="old_pwd"
                description="現在的密碼"
              >
                <b-form-input
                  id="old_pwd"
                  v-model="pwdForm.old_pwd"
                  type="password"
                ></b-form-input>
              </b-form-group-->
              <b-form-group id="new-password-field" label="新密碼：" label-for="new-password" :state="isPasswordValid">
                <b-form-input id="new-password" type="password" v-model="newPassword" :disabled="busy" :state="isPasswordValid"></b-form-input>
              </b-form-group>
              <b-form-group id="re-new-password-field" label="確認新密碼：" label-for="re-new-password" description="重新輸入新密碼" :state="isRePasswordValid">
                <b-form-input id="re-new-password" type="password" v-model="reNewPassword" :disabled="busy" :state="isRePasswordValid"></b-form-input>
              </b-form-group>
              <b-link href="#" @click="onReset">返回</b-link>
              <hr>
              <b-button type="submit" variant="primary" class="float-right" :disabled="busy">
                <b-spinner v-if="busy" small label="Spinning"></b-spinner>
                <span v-else>送出</span>
              </b-button>
            </b-form>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { State } from '../../library/EventBus.js'
import { EmailRegExp } from '../../library/Var.js'
export default {
  data () {
    return {
      currShow: 'data-form',
      username: '',
      name: '',
      email: '',
      newPassword: '',
      reNewPassword: '',
      busy: false
    }
  },
  computed: {
    showDataForm () {
      return this.currShow === 'data-form'
    },
    showResetPwdForm () {
      return this.currShow === 'reset-form'
    },
    isNameValid () {
      return this.name.length > 0
    },
    invalidNameFeedback () {
      if (this.name.length > 0) {
        return ''
      } else {
        return '不可空值'
      }
    },
    isEmailValid () {
      return EmailRegExp.test(this.email)
    },
    invalidEmailFeedback () {
      if (EmailRegExp.test(this.email)) {
        return ''
      } else if (this.email.length === 0) {
        return '不可空值'
      } else {
        return '格式不符'
      }
    },
    isPasswordValid () {
      return this.newPassword.length > 0
    },
    isRePasswordValid () {
      return this.isPasswordValid && this.newPassword === this.reNewPassword
    }
  },
  methods: {
    onReset () {
      const { username, name, email } = State.user
      this.username = username
      this.name = name
      this.email = email
      this.newPassword = ''
      this.reNewPassword = ''
      this.currShow = 'data-form'
    },
    async onSubmit () {
      if (this.busy) return
      this.busy = true
      const { username, name, email } = this
      try {
        await this.$api.putPersonalAdmin({ username, name, email })
        this.showToast(true)
        this.busy = false
        this.$bus.$emit('update:user')
      } catch (err) {
        this.busy = false
        this.showToast(false)
      }
    },
    async onSubmitReset () {
      if (this.busy || !this.isRePasswordValid) return
      this.busy = true
      const { newPassword: password } = this
      try {
        await this.$api.putPersonalAdminPwd({ password })
        this.busy = false
        this.showToast(true)
        this.onReset()
      } catch (err) {
        this.busy = false
        this.showToast(false)
      }
    },
    showToast (success) {
      if (success) {
        this.$bvToast.toast('您的資料已更新。', {
          title: '更新成功',
          variant: 'success'
        })
      } else {
        this.$bvToast.toast('連線異常，請嘗試多次，若仍發生請聯絡管理員。', {
          title: '更新失敗',
          variant: 'warning'
        })
      }
    }
  },
  mounted () {
    this.onReset()
    this.$bus.$emit('updated:user', this.onReset)
  }
}
</script>
